import { useEventCallback } from '@cian/react-utils';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { setLocationCookies } from './setLocationCookies';
import { trackLocationAgree, trackPopupClose } from './tracking';
import { LocationDetectModal } from '../../components/LocationDetectModal';
import { selectDetectedLocation } from '../../selectors/selectDetectedLocation';
// eslint-disable-next-line import/no-restricted-paths
import { removeCookie } from 'browser/utils/js-cookie';
import { DETECTED_REGION_ID_COOKIE_KEY } from 'shared/constants/detectedLocation';
import { NBSP } from 'shared/constants/symbols';
import { useApplicationContext } from 'shared/utils/applicationContext';

export const LocationDetectModalContainer = () => {
  const detectedLocation = useSelector(selectDetectedLocation);
  const { config, microfrontendsAPI, microfrontendsRegistry } = useApplicationContext();

  const subdomain = config.get<string>('subdomain');
  const [opened, setOpened] = React.useState(true);

  React.useEffect(() => {
    // Если определенный регион совпадает с регионом в куках, то удаляем куки,
    // чтобы не показывать попап при каждом заходе на сайт
    if (detectedLocation && subdomain && detectedLocation.baseHost.includes(subdomain)) {
      removeCookie(DETECTED_REGION_ID_COOKIE_KEY);
    }
  }, [detectedLocation, subdomain]);

  const title = React.useMemo(() => {
    if (!detectedLocation) {
      return '';
    }

    const { displayName } = detectedLocation;

    return `Ваш${NBSP}регион${NBSP}для${NBSP}поиска ${displayName}?`;
  }, [detectedLocation]);

  const onOpenChange = useEventCallback((open: boolean) => {
    if (detectedLocation && !open) {
      trackPopupClose(detectedLocation.displayName || '');
    }

    setOpened(open);
  });

  const onAgree = useEventCallback(() => {
    if (detectedLocation) {
      trackLocationAgree(detectedLocation.displayName || '');
      setLocationCookies(detectedLocation.id, detectedLocation.displayName || '', detectedLocation.mainTownId);
      removeCookie(DETECTED_REGION_ID_COOKIE_KEY);

      if (subdomain && detectedLocation.baseHost.includes(subdomain)) {
        setOpened(false);

        return;
      }

      window.location.href = `${detectedLocation.baseHost}${window.location.pathname}${window.location.search}`;
    }
  });

  const onRegionChange = useEventCallback(() => {
    setOpened(false);
    removeCookie(DETECTED_REGION_ID_COOKIE_KEY);

    if (microfrontendsRegistry.microfrontend('desktop-filters-micro-frontend') && microfrontendsAPI) {
      microfrontendsAPI.getDesktopFiltersMicrofrontendApi().openGeoModal();
    }
  });

  if (!detectedLocation || !opened) {
    return null;
  }

  return (
    <LocationDetectModal title={title} onOpenChange={onOpenChange} onAgree={onAgree} onRegionChange={onRegionChange} />
  );
};
